module.exports = __webpack_public_path__ + "img/edit.45fbab24.svg";